<template>
  <v-form class="pt-4" ref="formFiltro">
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field v-model="filter.nombre" :label="filterTexto" :placeholder="filterTexto" outlined
          class="rounded-lg" clearable dense :error-messages="filterNombreErrors" maxlength="51"
          @keyup="filterNombre($event, true)" @click:clear="filter.nombre = null; $emit('filtrar')" />
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete :search-input.sync="btext" v-model="filter.estado" :items="filterEstado.items"
          :item-text="filterEstado.text" :item-value="filterEstado.value" :label="filterEstado.label"
          :placeholder="filterEstado.label" dense outlined @keyup="buscar(true)" clearable
          @click:clear="filter.estado = null; $emit('filtrar')" @change="filtrarEstado()" class="rounded-lg">

          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="custom-item-class">{{ item.nombre }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" lg="3">
        <v-btn class="lowercase-text px-4 mr-2" color="primary" style="text-transform: none !important" rounded
          :block="$vuetify.breakpoint.smAndDown" @click="buscar(), $emit('filtrar')">
          Buscar
        </v-btn>
        <v-btn class="lowercase-text px-4" color="primary" style="text-transform: none !important" rounded outlined
          :block="$vuetify.breakpoint.smAndDown" @click="$refs.formFiltro.reset(), $emit('filtrar')">
          Limpiar
        </v-btn>
      </v-col>

    </v-row>
    <v-row justify="end" class="pb-3" color="primary">
      <v-col cols="12" sm="4" md="2" lg="2" class="text-right">
        <slot name="btnAccion" class="btn-text"></slot>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import {maxLength, helpers} from "vuelidate/lib/validators";

export default {
  props: {
    filterEstado:{
      type: Object,
      default:()=>({
        items:[],
        text:'nombre',
        value:'id',
        label: ''
      })
    },
    filterTexto:{
      type: String,
      default: 'Nombre'
    },
    refPadre:{
      type: Object,
      default: ()=>{}
    }
  },
    data: ()=> ({
        filter:{
            nombre:'',
            estado:null,
        },
      btext:'',
      nombre: false,
    }),
    methods: {
      async buscar(typing = false) {
        if (typing) {
          await this.timeout()
        }
        if (this.btext && this.btext.length > 3) {
            this.$emit('buscar', this.btext)
        }

      },
      filtrarEstado() {
        this.$emit('filtrar')
      },

      timeout(ms = 500) {
        if (this.searchTimeout) {
          clearInterval(this.searchTimeout)
        }
        return new Promise((resolve) => {
          this.searchTimeout = setTimeout(resolve, ms)
        })
      },

      async filterNombre(event, typing = false) {
        if (typing) {
          await this.timeout()
        }

        if ((this.filter.nombre && this.filter.nombre.length > 3) || this.filter.nombre.length === 0 ) {
          if(this.nombre === true) {
            this.$emit('filtrar')
          }
        }
      },
    },
  validations() {
    const notAlphanumeric = (value) => {
      const alphanumericRegex = /[^a-zA-Z0-9ñÑ ]/;
      return !alphanumericRegex.test(value);
    };

    return {
      filter: {
        nombre: {
          maxLength: maxLength(50),
          notAlphanumeric: notAlphanumeric
        }
      },
    }
  },
  computed: {
    filterNombreErrors(){
      const errors = [];
      if (!this.$v.filter.nombre.notAlphanumeric) errors.push("Solo se permiten caracteres alfanuméricos");
      if (!this.$v.filter.nombre.maxLength) errors.push("Máximo 50 caracteres");
      if(errors.length <= 0 ){
        this.nombre = true
      }else{
        this.nombre = false;
      }
      return errors;
    }
  },
}
</script>

<style>
.custom-item-class {
    min-width: 100%;
    max-width: 185px;
}

</style>
